import * as React from 'react';
import { ApolloProvider } from '@apollo/client';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import 'unorm';

import { client } from './api/connection';
import AuthRoute from './components/auth/AuthRoute';
import PlantActions from './components/plant/PlantActions';
import DevContainer from './containers/_dev/DevContainer';
import PlantOnboardingContainer from './containers/admin/onboarding/PlantOnboardingContainer';
import AcceptInvitationContainer from './containers/auth/AcceptInvitationContainer';
import ForgotPasswordContainer from './containers/auth/ForgotPasswordContainer';
import LoginContainer from './containers/auth/LoginContainer';
import PasswordResetContainer from './containers/auth/PasswordResetContainer';
import BasketListContainer from './containers/BasketListContainer';
import BasketUpdateContainer from './containers/BasketUpdateContainer';
import DashboardContainer from './containers/DashboardContainer';
import GroupListContainer from './containers/GroupListContainer';
import NotFoundContainer from './containers/NotFoundContainer';
import OpsContainer from './containers/OpsContainer';
import PlantListContainer from './containers/PlantListContainer';
import ProfileContainer from './containers/ProfileContainer';
import SearchContainer from './containers/SearchContainer';
import SpacyConverterContainer from './containers/SpacyConverterContainer';
import TagListContainer from './containers/TagListContainer';
import TagUpdateContainer from './containers/TagUpdateContainer';
import UserListContainer from './containers/UserListContainer';
import { GlobalRole } from './models/IUserModel';
import Routing from './Routing';
import Tracker from './utils/Tracker';

class App extends React.Component<any, any> {
    public constructor(props) {
        super(props);
        Tracker.init();
    }

    public render() {
        return (
            <ApolloProvider client={client}>
                <Router>
                    <Routes>
                        {/*  PUBLIC ROUTES  */}
                        <Route
                            path={Routing.AUTH_LOGIN.route}
                            element={<LoginContainer />}
                        />
                        <Route
                            path={Routing.AUTH_FORGOT_PASSWORD.route}
                            element={<ForgotPasswordContainer />}
                        />
                        <Route
                            path={Routing.AUTH_RESET_PASSWORD.route}
                            element={<PasswordResetContainer />}
                        />
                        <Route
                            path={Routing.AUTH_ACCEPT_INVITATION.route}
                            element={<AcceptInvitationContainer />}
                        />

                        {/*  ADMIN ROUTES  */}
                        <Route
                            path={Routing.USER_LIST.route}
                            element={<AuthRoute component={UserListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.USER_DETAILS.route}
                            element={<AuthRoute component={UserListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.USER_CREATE.route}
                            element={<AuthRoute component={UserListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.ADMIN_CREATE.route}
                            element={<AuthRoute component={UserListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.SEARCH_PLANT.route}
                            element={<AuthRoute component={SearchContainer} />}
                        />
                        <Route
                            path={Routing.GROUPS.route}
                            element={<AuthRoute component={GroupListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.GROUP_CREATE.route}
                            element={<AuthRoute component={GroupListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.GROUP_DETAILS.route}
                            element={<AuthRoute component={GroupListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANTS.route}
                            element={<AuthRoute component={PlantListContainer} />}
                        />
                        <Route
                            path={Routing.PLANT_CREATE.route}
                            element={<AuthRoute component={PlantListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANT_STATS.route}
                            element={<AuthRoute component={PlantListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANT_ACTIONS.route}
                            element={<AuthRoute component={PlantActions} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANT_DETAILS.route}
                            element={<AuthRoute component={PlantListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANT_INDEX_STATUS.route}
                            element={<AuthRoute component={PlantOnboardingContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANT_ONBOARDING.route}
                            element={<AuthRoute component={PlantOnboardingContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.PLANT_TAGS.route}
                            element={<AuthRoute component={TagListContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.OPS.route}
                            element={<AuthRoute component={OpsContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />
                        <Route
                            path={Routing.TAG_DETAILS.route}
                            element={<AuthRoute component={TagUpdateContainer} whitelistRole={GlobalRole.linde_admin} />}
                        />

                        {/*  LOGGED IN ROUTES  */}
                        <Route
                            path={Routing.INDEX.route}
                            element={<AuthRoute component={DashboardContainer} />}
                        />
                        <Route
                            path={Routing.BASKETS.route}
                            element={<AuthRoute component={BasketListContainer} />}
                        />
                        <Route
                            path={Routing.BASKET_DETAILS.route}
                            element={<AuthRoute component={BasketUpdateContainer} />}
                        />
                        <Route
                            path={Routing.PROFILE.route}
                            element={<AuthRoute component={ProfileContainer} />}
                        />
                        <Route
                            path={Routing.SPACY_CONVERTER.route}
                            element={<AuthRoute component={SpacyConverterContainer} />}
                        />

                        {/*  DEV  */}
                        <Route path="/dev/:subcomponent?" element={<DevContainer />} />

                        {/*  CATCH  */}
                        <Route path="*" element={<AuthRoute component={NotFoundContainer} />} />
                    </Routes>
                </Router>
            </ApolloProvider>
        );
    }
}

export default App;
